import React from "react";
import { Modal, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "4px",
  p: 1,
  zIndex: 1300,
  outline: "none",
};

const closeButtonStyle = {
  position: "absolute",
  top: "-46px",
  left: "50%",
  transform: "translateX(-50%)",
  backgroundColor: "#fff",
  color: "#000",
  borderRadius: "50%",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.35)",
  zIndex: 1400,
};

const VideoModal = ({ open, onClose, videoUrl }) => {
  const getEmbedUrl = (url) => {
    try {
      const urlObj = new URL(url);
      if (urlObj.hostname === "youtu.be") {
        return `https://www.youtube.com/embed/${urlObj.pathname.slice(1)}`;
      }
      if (
        urlObj.hostname.includes("youtube.com") &&
        urlObj.searchParams.get("v")
      ) {
        return `https://www.youtube.com/embed/${urlObj.searchParams.get("v")}`;
      }
      return url;
    } catch {
      return "";
    }
  };

  const embedUrl = getEmbedUrl(videoUrl);

  return (
    <Modal
      open={open}
      onClose={onClose}
      BackdropProps={{
        sx: { backgroundColor: "rgba(0, 0, 0, 0.9)" },
      }}
    >
      <Box sx={modalStyle}>
        <IconButton onClick={onClose} sx={closeButtonStyle}>
          <CloseIcon />
        </IconButton>
        <div style={{ position: "relative", paddingTop: "56.25%" }}>
          {embedUrl ? (
            <iframe
              src={embedUrl}
              title="Product Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
              }}
            ></iframe>
          ) : (
            <p style={{ textAlign: "center", color: "red" }}>
              Invalid video URL
            </p>
          )}
        </div>
      </Box>
    </Modal>
  );
};

export default VideoModal;
